// import React from 'react'
// import Header from './Header'
// import Backdrop from '../Assets/Assests/Landscape-trees-mountains.jpg'
// import Tesla from '../Assets/Assests/nikolas-tesla.png'
// import Footer from './Footer'

// const Wellness = () => {
//   const studentIssues = [
//     [
//       'Academic Stress',
//       'Social Anxiety',
//       'Exam Anxiety',
//       'Depression',
//       'Bullying and Cyberbullying',
//       'Peer Pressure',
//       'Burnout',
//       'Part time jobs and workload balance',
//     ],
//     [
//       'Psychotic',
//       'Adjustments to College/University Life',
//       'Sleep problems and Insomnia',
//       'Bipolar Disorder',
//       'Attention Deficit Hyperactive Disorder(ADHD)',
//       'Transition to work/life after graduation',
//     ],
//     [
//       'Eating disorders (anorexia, bulimia, binge eating)',
//       'Substance Abuse',
//       'Tobacco Addiction',
//       'Alcohol Addiction',
//       'LGBTQ+ Mental issues',
//       'Neurodevelopmental',
//       'MDMA Misuse',
//     ],
//     [
//       'Relationship Stress',
//       'Financial Stress',
//       'Suicide/Suicide Ideation/Self Harm',
//       'Post Traumatic Stress Disorder(PTSD)',
//       'Loneliness and Isolation',
//       'HIV',
//       'Mood',
//     ],
//     [
//       'Test performance pressure from parents',
//       'Digital/Screen Addiction',
//       'Gender Identity and Dysphoria',
//       'Impact of family dynamics',
//       'Abuse',
//       'Obsessive Compulsive Disorder',
//     ],
//   ]

//   const professionalIssues = [
//     [
//       'Workplace Stress',
//       'Burnout',
//       'Work-life Balance',
//       'Job Insecurity',
//       'Performance Anxiety',
//       'Workplace bullying or Harassment',
//     ],
//     [
//       'Mental health stigma in workplace',
//       'Conflict with Colleagues',
//       'Anxiety Disorders',
//       'Depression',
//       'Substance use and dependence',
//     ],
//     [
//       'Eating Disorders',
//       'Psychosis',
//       'Obsessive compulsive disorder',
//       'Relationship issues',
//       'Suicide/Ideation/Self harm',
//       'Post traumatic stress disorder',
//     ],
//     [
//       'MDMA Use',
//       'Bipolar Disorder',
//       'Neurodevelopmental',
//       'Personality',
//       'Psychotic',
//       'Mood',
//     ],
//     ['HIV', 'Tobacco addiction', 'Alcohol addiction', 'Discrimination at work'],
//   ]

//   const sectionStyle = {
//     backgroundColor: '#EAFAEF',
//     borderRadius: '15px',
//     padding: '30px',
//     marginBottom: '40px',
//     boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
//   }

//   const titleStyle = {
//     color: '#2c5282',
//     fontSize: '1.8rem',
//     fontWeight: '600',
//     textAlign: 'center',
//     marginBottom: '30px',
//     lineHeight: '1.4',
//   }

//   const listItemStyle = {
//     color: '#4a5568',
//     fontSize: '0.95rem',
//     marginBottom: '8px',
//     lineHeight: '1.4',
//     position: 'relative',
//     paddingLeft: '15px',
//   }

//   return (
//     <>
//       <Header />

//       <div className='min-h-screen'>
//         <header
//           id='home'
//           className='container-fluid text-white d-flex align-items-center justify-content-center'
//           style={{
//             backgroundImage: `url(${Backdrop})`,
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             height: '550px',
//             opacity: '0.7',
//             position: 'relative',
//             top: '75px',
//           }}
//         >
//           <div
//             className='text-center px-3 py-3'
//             style={{
//               zIndex: 2,
//               borderRadius: '10px',
//             }}
//           >
//             <h1
//               style={{
//                 fontFamily: 'Inter',
//                 fontWeight: '600',
//                 fontSize: '50px',
//                 color: '#2D5272',
//               }}
//             >
//               Tesla Bird Mental Wellness Initiative –
//               <span
//                 className='mb-2'
//                 style={{
//                   fontFamily: 'Inter',
//                   fontWeight: '600',
//                   fontSize: '50px',
//                   color: '#889E7E',
//                 }}
//               >
//                 A <br />
//                 Stronger Mind for a Better Tomorrow
//               </span>
//             </h1>
//           </div>
//         </header>
//         <div className='container py-5 mt-5 '>
//           <div className='justify-content-center'>
//             <h1
//               style={{
//                 fontFamily: 'Inter',
//                 fontWeight: '600',
//                 fontSize: '32px',
//                 color: '#2D5272',
//               }}
//             >
//               A New Dawn for Mental Wellness in India
//             </h1>
//             <span
//               style={{
//                 fontFamily: 'Inter',
//                 fontWeight: '500',
//                 fontSize: '16px',
//                 color: '#2D5272',
//               }}
//             >
//               In today’s high-pressure world, stress, burnout, and emotional
//               fatigue are quietly becoming a crisis—especially in India. From
//               students to working professionals, millions are silently
//               struggling with anxiety, depression, and sleep disorders. Tesla
//               Bird is here to change that.
//             </span>
//             <br />
//             <span
//               style={{
//                 fontFamily: 'Inter',
//                 fontWeight: '500',
//                 fontSize: '16px',
//                 color: '#2D5272',
//               }}
//             >
//               We’re a next-generation mental health platform blending
//               technology, science, and empathy to make mental wellness
//               accessible, culturally relevant, and deeply human.
//             </span>
//           </div>
//         </div>
//         <div
//           className='container-fluid p-0'
//           style={{ backgroundColor: 'white' }}
//         >
//           <div
//             className='row'
//             style={{
//               backgroundColor: '#FFF',
//               minHeight: '400px',
//               padding: '60px 0',
//               margin: '0',
//             }}
//           >
//             <div className='col-12'>
//               <div className='container'>
//                 <div className='row align-items-center'>
//                   <div className='col-lg-8 col-md-7 col-12'>
//                     <h2
//                       className='mb-4'
//                       style={{
//                         fontSize: 'clamp(1.6rem, 3.5vw, 2.2rem)',
//                         fontWeight: '600',
//                         lineHeight: '140%',
//                         fontFamily: 'Inter',
//                       }}
//                     >
//                       <span style={{ color: '#2D5272' }}>
//                         Inspired by Tesla. Powered by Compassion.
//                       </span>
//                       <span style={{ color: '#889E7E' }}></span>
//                     </h2>
//                     <p
//                       style={{
//                         fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
//                         lineHeight: '180%',
//                         maxWidth: '100%',
//                         wordWrap: 'break-word',
//                         fontFamily: 'Inter',
//                         fontWeight: '400',
//                         color: '#666666',
//                       }}
//                     >
//                       Named in honor of inventor Nikola Tesla, who himself faced
//                       emotional breakdowns despite his brilliance, Tesla Bird is
//                       about more than just therapy—it’s about illumination.
//                       India’s mental health crisis is growing rapidly. According
//                       to the National Institute of Mental Health and
//                       Neurosciences (NIMHANS), one in seven Indians suffers from
//                       some form of mental disorder. For students, the pressure
//                       of academic performance, social expectations, and an
//                       uncertain future can be overwhelming. For working
//                       professionals, long hours, digital fatigue, and lack of
//                       work-life balance often lead to depression, anxiety, and
//                       sleep disorders. In fact, a 2024 World Health Organization
//                       (WHO) report ranked India among the top five most stressed
//                       nations globally. At the heart of our platform is Aarava,
//                       an AI-powered therapy companion offering 24/7 support in
//                       multiple Indian languages. Aarava uses techniques like
//                       CBT, mindfulness, and behavior science to offer real-time
//                       help—grounded in cultural realities, not just clinical
//                       jargon. We partner with experts, governments, and
//                       institutions like WHO and NIMHANS to ensure everything we
//                       build is credible and inclusive.
//                     </p>
//                   </div>
//                   <div className='col-lg-4 col-md-5 col-12 mb-4 mb-md-0 d-flex justify-content-center'>
//                     <div style={{ maxWidth: '280px', width: '100%' }}>
//                       <img
//                         src={Tesla}
//                         alt='nikolas-tesla'
//                         className='img-fluid'
//                         style={{
//                           zIndex: 2,
//                           maxWidth: '70%',
//                           height: 'auto',
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className='container py-5  '>
//           <div className='justify-content-center'>
//             <h1
//               style={{
//                 fontFamily: 'Inter',
//                 fontWeight: '600',
//                 fontSize: '32px',
//                 color: '#2D5272',
//               }}
//             >
//               From Stress to Strength - Real Impact, Real People
//             </h1>
//             <span
//               style={{
//                 fontFamily: 'Inter',
//                 fontWeight: '500',
//                 fontSize: '16px',
//                 color: '#2D5272',
//               }}
//             >
//               Whether it's campuses, offices, or rural communities, Tesla Bird
//               is transforming how India deals with mental wellness. With over
//               100,000 users impacted, our data shows a 40% improvement in
//               emotional well-being in just 3 months using tools like the Tesla
//               Bird.One of our core innovations is the Tesla Bird Happiness
//               Index—a unique well-being assessment tool designed to measure
//               emotional wellness across age groups and work environments. Using
//               this index, companies and institutions can track burnout,
//               motivation, and mental resilience while taking timely action to
//               improve them. Early pilot studies using the index have shown a 40%
//               improvement in emotional well-being among participants over three
//               months.
//             </span>
//             <br />
//             <span
//               style={{
//                 fontFamily: 'Inter',
//                 fontWeight: '500',
//                 fontSize: '16px',
//                 color: '#2D5272',
//               }}
//             >
//               We’re a next-generation mental health platform blending
//               technology, science, and empathy to make mental wellness
//               accessible, culturally relevant, and deeply human.
//             </span>
//           </div>
//         </div>

//         <div className='container'>
//           {/* Header Section */}
//           <div className='row mb-5 align-items-stretch'>
//             <div className='col-lg-6 col-md-6 col-12 text-center'>
//               <h2
//                 style={{
//                   backgroundImage:
//                     'linear-gradient(90deg, #87A3BB -23.85%, #2D5272 128.3%)',
//                   backgroundClip: 'text',
//                   WebkitBackgroundClip: 'text',
//                   color: 'transparent',
//                   WebkitTextFillColor: 'transparent',
//                   fontSize: '32px',
//                   fontFamily: 'Inter, sans-serif',
//                   fontWeight: 600,
//                   display: 'inline-block',
//                 }}
//               >
//                 — Our services include
//               </h2>
//             </div>

//             {/* Face to face group session */}
//             <div className='col-lg-6 col-md-6 col-12 d-flex justify-content-center'>
//               <div
//                 className='card border-0 shadow-sm h-100'
//                 style={{
//                   backgroundColor: '#2D5272',
//                   borderRadius: '20px',
//                   color: 'white',
//                   width: '100%',
//                   maxWidth: '450px',
//                 }}
//               >
//                 <div className='card-body p-4'>
//                   <div className='d-flex justify-content-between align-items-start mb-3'>
//                     <h5
//                       className='card-title fw-bold mb-0'
//                       style={{ fontSize: '1.2rem' }}
//                     >
//                       Face to face group session
//                     </h5>
//                     <div style={{ fontSize: '1.5rem', marginLeft: '15px' }}>
//                       👥
//                     </div>
//                   </div>
//                   <p
//                     className='card-text'
//                     style={{
//                       fontSize: '0.9rem',
//                       lineHeight: '1.5',
//                       opacity: '0.9',
//                     }}
//                   >
//                     Join our in-person sessions for guided discussions, shared
//                     learning, and real-time connection in a supportive group
//                     setting.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Services Grid */}
//           <div className='row mb-5 align-items-stretch'>
//             {/* Health Checks and Consultation */}
//             <div className='col-lg-6 col-md-6 col-12 mb-3 d-flex justify-content-center'>
//               <div
//                 className='card border-0 shadow-sm h-100'
//                 style={{
//                   backgroundColor: '#2D5272',
//                   borderRadius: '20px',
//                   color: 'white',
//                   width: '100%',
//                   maxWidth: '450px',
//                 }}
//               >
//                 <div className='card-body p-4'>
//                   <div className='d-flex justify-content-between align-items-start mb-3'>
//                     <h5
//                       className='card-title fw-bold mb-0'
//                       style={{ fontSize: '1.2rem' }}
//                     >
//                       Health Checks and Consultation
//                     </h5>
//                     <div style={{ fontSize: '1.5rem', marginLeft: '15px' }}>
//                       🩺
//                     </div>
//                   </div>
//                   <p
//                     className='card-text'
//                     style={{
//                       fontSize: '0.9rem',
//                       lineHeight: '1.5',
//                       opacity: '0.9',
//                     }}
//                   >
//                     Quick health assessments and expert guidance to support
//                     early detection, prevention, and overall wellbeing.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Aarava - 24/7 AI Therapist */}
//             <div className='col-lg-6 col-md-6 col-12 mb-3 d-flex justify-content-center'>
//               <div
//                 className='card border-0 shadow-sm h-100'
//                 style={{
//                   backgroundColor: '#2D5272',
//                   borderRadius: '20px',
//                   color: 'white',
//                   width: '100%',
//                   maxWidth: '450px',
//                 }}
//               >
//                 <div className='card-body p-4'>
//                   <div className='d-flex justify-content-between align-items-start mb-3'>
//                     <h5
//                       className='card-title fw-bold mb-0'
//                       style={{ fontSize: '1.2rem' }}
//                     >
//                       Aarava - 24/7 AI Therapist
//                     </h5>
//                     <div style={{ fontSize: '1.5rem', marginLeft: '15px' }}>
//                       🤖
//                     </div>
//                   </div>
//                   <p
//                     className='card-text'
//                     style={{
//                       fontSize: '0.9rem',
//                       lineHeight: '1.5',
//                       opacity: '0.9',
//                     }}
//                   >
//                     Your always-available AI companion for mental health
//                     support—chat anytime for guidance, coping tools, and
//                     emotional check-ins.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className='row mt-5 align-items-stretch'>
//             {/* Mental wellness kits */}
//             <div className='col-lg-6 col-md-6 col-12 mb-3 d-flex justify-content-center'>
//               <div
//                 className='card border-0 shadow-sm h-100'
//                 style={{
//                   backgroundColor: '#2D5272',
//                   borderRadius: '20px',
//                   color: 'white',
//                   width: '100%',
//                   maxWidth: '450px',
//                 }}
//               >
//                 <div className='card-body p-4'>
//                   <div className='d-flex justify-content-between align-items-start mb-3'>
//                     <h5
//                       className='card-title fw-bold mb-0'
//                       style={{ fontSize: '1.2rem' }}
//                     >
//                       Mental wellness kits
//                     </h5>
//                     <div style={{ fontSize: '1.5rem', marginLeft: '15px' }}>
//                       📦
//                     </div>
//                   </div>
//                   <p
//                     className='card-text'
//                     style={{
//                       fontSize: '0.9rem',
//                       lineHeight: '1.5',
//                       opacity: '0.9',
//                     }}
//                   >
//                     Ready-to-use kits with tools, resources, and activities to
//                     support mental, physical, and emotional wellbeing in local
//                     communities.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* WHO Approved Assessments */}
//             <div className='col-lg-6 col-md-6 col-12 mb-3 d-flex justify-content-center'>
//               <div
//                 className='card border-0 shadow-sm h-100'
//                 style={{
//                   backgroundColor: '#2D5272',
//                   borderRadius: '20px',
//                   color: 'white',
//                   width: '100%',
//                   maxWidth: '450px',
//                 }}
//               >
//                 <div className='card-body p-4'>
//                   <div className='d-flex justify-content-between align-items-start mb-3'>
//                     <h5
//                       className='card-title fw-bold mb-0'
//                       style={{ fontSize: '1.2rem' }}
//                     >
//                       WHO Approved Assessments
//                     </h5>
//                     <div style={{ fontSize: '1.5rem', marginLeft: '15px' }}>
//                       📋
//                     </div>
//                   </div>
//                   <p
//                     className='card-text'
//                     style={{
//                       fontSize: '0.9rem',
//                       lineHeight: '1.5',
//                       opacity: '0.9',
//                     }}
//                   >
//                     Standardized mental health and wellbeing tools validated by
//                     the World Health Organization for accurate, reliable
//                     insights.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Bottom Section */}
//           <div className='row mt-5'>
//             <div className='col-12'>
//               <div className='mb-2'>
//                 <h2
//                   style={{
//                     color: '#2D5272',
//                     fontSize: '2.5rem',
//                     fontWeight: '600',
//                     marginBottom: '2rem',
//                   }}
//                 >
//                   Wellness for Everyone, Everywhere
//                 </h2>
//               </div>
//               <div className='row'>
//                 <div className='col-lg-10 col-12'>
//                   <div
//                     style={{
//                       color: '#6c757d',
//                       fontSize: '1rem',
//                       lineHeight: '1.8',
//                     }}
//                   >
//                     <p className='mb-3'>
//                       Mental health is not one-size-fits-all. That's why we go
//                       local—with content and care available in Kannada, Hindi,
//                       Tamil, and English. We reach beyond screens—with on-ground
//                       workshops, telehealth networks, and our "Mental Health in
//                       a Box" kits delivered to schools, small businesses, and
//                       healthcare centers—bringing structured, scalable care to
//                       the grassroots.
//                     </p>
//                     <p className='mb-3'>
//                       Tesla Bird is building a future where mental health is not
//                       a luxury, but a right.
//                     </p>
//                     <p className='mb-3'>
//                       Mental health has historically received less than 1% of
//                       India's total health budget. Tesla Bird is determined to
//                       bridge this gap through scalable, cost-effective, and
//                       culturally sensitive solutions. Our "Mental Health in a
//                       Box" initiative delivers comprehensive mental health
//                       resources to small businesses, schools, and healthcare
//                       centers, enabling grassroots impact.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className='container'>
//           {/* Students Section */}
//           <h2 style={titleStyle}>
//             Some of the top mental health issues in students :
//           </h2>
//           <div style={sectionStyle}>
//             <div className='row g-4'>
//               {studentIssues.map((column, columnIndex) => (
//                 <div key={columnIndex} className='col-lg col-md-6 col-12'>
//                   <ul style={{ padding: 0, margin: 0 }}>
//                     {column.map((issue, index) => (
//                       <li key={index} style={listItemStyle}>
//                         {issue}
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Working Professionals Section */}
//           <h2 style={titleStyle}>
//             Some of the top mental health issues in working professionals :
//           </h2>
//           <div style={sectionStyle}>
//             <div className='row g-4'>
//               {professionalIssues.map((column, columnIndex) => (
//                 <div key={columnIndex} className='col-lg col-md-6 col-12'>
//                   <ul style={{ padding: 0, margin: 0 }}>
//                     {column.map((issue, index) => (
//                       <li key={index} style={listItemStyle}>
//                         {issue}
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className='row mb-5'>
//             <div className='col-lg-10 col-12'>
//               <div
//                 style={{
//                   color: '#6c757d',
//                   fontSize: '1rem',
//                   lineHeight: '1.8',
//                 }}
//               >
//                 <p className='mb-3'>
//                   With support from education policy makers and corporate
//                   leaders, Tesla Bird is now working to integrate wellness
//                   programs into the National Education Policy (NEP) and
//                   state-level employee welfare schemes. Globally, we are
//                   aligning with the WHO’s digital mental health agenda to scale
//                   our solutions across Asia and Africa.
//                 </p>
//                 <p className='mb-3'>
//                   Tesla Bird isn’t just a platform—it’s a movement to make
//                   mental health mainstream. We are reimagining therapy,
//                   normalizing emotional conversations, and fostering a
//                   generation that values psychological fitness as much as
//                   physical health.
//                 </p>
//                 <p className='mb-5'>
//                   Whether you’re a student facing exam stress, a professional
//                   battling burnout, or a homemaker seeking peace of mind—Tesla
//                   Bird is here for you.
//                 </p>
//                 <h2>
//                   Join us as we help India and the world heal, grow, and
//                   thrive—one mind at a time.
//                 </h2>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Custom CSS for responsive behavior */}
//         <style jsx>{`
//           @media (max-width: 768px) {
//             .card {
//               margin-top: 0 !important;
//               max-width: 100% !important;
//             }

//             h2 {
//               font-size: 1.8rem !important;
//             }

//             .card-title {
//               font-size: 1.1rem !important;
//             }

//             .card-text {
//               font-size: 0.85rem !important;
//             }
//           }

//           @media (max-width: 576px) {
//             .container-fluid {
//               padding: 20px 15px !important;
//             }

//             h2 {
//               font-size: 1.5rem !important;
//             }

//             .card-body {
//               padding: 1.5rem !important;
//             }
//           }
//         `}</style>

//         <Footer />
//       </div>
//     </>
//   )
// }

// export default Wellness

import Header from './Header'
import Backdrop from '../Assets/Assests/Landscape-trees-mountains.jpg'
import Tesla from '../Assets/Assests/nikolas-tesla.png'
import Footer from './Footer'

const Wellness = () => {
  const studentIssues = [
    [
      'Academic Stress',
      'Social Anxiety',
      'Exam Anxiety',
      'Depression',
      'Bullying and Cyberbullying',
      'Peer Pressure',
      'Burnout',
      'Part time jobs and workload balance',
    ],
    [
      'Psychotic',
      'Adjustments to College/University Life',
      'Sleep problems and Insomnia',
      'Bipolar Disorder',
      'Attention Deficit Hyperactive Disorder(ADHD)',
      'Transition to work/life after graduation',
    ],
    [
      'Eating disorders (anorexia, bulimia, binge eating)',
      'Substance Abuse',
      'Tobacco Addiction',
      'Alcohol Addiction',
      'LGBTQ+ Mental issues',
      'Neurodevelopmental',
      'MDMA Misuse',
    ],
    [
      'Relationship Stress',
      'Financial Stress',
      'Suicide/Suicide Ideation/Self Harm',
      'Post Traumatic Stress Disorder(PTSD)',
      'Loneliness and Isolation',
      'HIV',
      'Mood',
    ],
    [
      'Test performance pressure from parents',
      'Digital/Screen Addiction',
      'Gender Identity and Dysphoria',
      'Impact of family dynamics',
      'Abuse',
      'Obsessive Compulsive Disorder',
    ],
  ]

  const professionalIssues = [
    [
      'Workplace Stress',
      'Burnout',
      'Work-life Balance',
      'Job Insecurity',
      'Performance Anxiety',
      'Workplace bullying or Harassment',
    ],
    [
      'Mental health stigma in workplace',
      'Conflict with Colleagues',
      'Anxiety Disorders',
      'Depression',
      'Substance use and dependence',
    ],
    [
      'Eating Disorders',
      'Psychosis',
      'Obsessive compulsive disorder',
      'Relationship issues',
      'Suicide/Ideation/Self harm',
      'Post traumatic stress disorder',
    ],
    [
      'MDMA Use',
      'Bipolar Disorder',
      'Neurodevelopmental',
      'Personality',
      'Psychotic',
      'Mood',
    ],
    ['HIV', 'Tobacco addiction', 'Alcohol addiction', 'Discrimination at work'],
  ]

  const sectionStyle = {
    backgroundColor: '#EAFAEF',
    borderRadius: '15px',
    padding: 'clamp(20px, 4vw, 30px)',
    marginBottom: '40px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
  }

  const titleStyle = {
    color: '#2c5282',
    fontSize: 'clamp(1.3rem, 4vw, 1.8rem)',
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: '30px',
    lineHeight: '1.4',
  }

  const listItemStyle = {
    color: '#4a5568',
    fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
    marginBottom: '8px',
    lineHeight: '1.4',
    position: 'relative',
    paddingLeft: '15px',
  }

  return (
    <>
      <Header />

      <div className='min-vh-100'>
        {/* Hero Section */}
        <header
          id='home'
          className='container-fluid text-white d-flex align-items-center justify-content-center px-3 py-4'
          style={{
            backgroundImage: `url(${Backdrop || '/placeholder.svg'})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: '400px',
            opacity: '0.7',
            position: 'relative',
            top: '40px',
          }}
        >
          <div
            className='text-center px-2 py-3 w-100'
            style={{
              zIndex: 2,
              borderRadius: '10px',
            }}
          >
            <h1
              className='mb-0'
              style={{
                fontFamily: 'Inter',
                fontWeight: '600',
                fontSize: 'clamp(1.8rem, 6vw, 3.2rem)',
                color: '#2D5272',
                lineHeight: '1.2',
              }}
            >
              Tesla Bird Mental Wellness Initiative –
              <span
                className='d-block mt-2'
                style={{
                  fontFamily: 'Inter',
                  fontWeight: '600',
                  fontSize: 'clamp(1.8rem, 6vw, 3.2rem)',
                  color: '#889E7E',
                }}
              >
                A Stronger Mind for a Better Tomorrow
              </span>
            </h1>
          </div>
        </header>

        {/* Introduction Section */}
        <div className='container py-4 py-md-5 py-sm-5 mt-4 mt-md-5 mt-sm-5'>
          <div className='row justify-content-center'>
            <div className='col-12 col-lg-10'>
              <h1
                className='mb-3 mb-md-4 text-center text-lg-start'
                style={{
                  fontFamily: 'Inter',
                  fontWeight: '600',
                  fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                  color: '#2D5272',
                }}
              >
                A New Dawn for Mental Wellness in India
              </h1>
              <p
                className='mb-3 text-center text-lg-start'
                style={{
                  fontFamily: 'Inter',
                  fontWeight: '500',
                  fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                  color: '#2D5272',
                  lineHeight: '1.6',
                }}
              >
                In today's high-pressure world, stress, burnout, and emotional
                fatigue are quietly becoming a crisis—especially in India. From
                students to working professionals, millions are silently
                struggling with anxiety, depression, and sleep disorders. Tesla
                Bird is here to change that.
              </p>
              <p
                className='text-center text-lg-start'
                style={{
                  fontFamily: 'Inter',
                  fontWeight: '500',
                  fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                  color: '#2D5272',
                  lineHeight: '1.6',
                }}
              >
                We're a next-generation mental health platform blending
                technology, science, and empathy to make mental wellness
                accessible, culturally relevant, and deeply human.
              </p>
            </div>
          </div>
        </div>

        {/* Tesla Inspiration Section */}
        <div
          className='container-fluid p-0'
          style={{ backgroundColor: 'white' }}
        >
          <div
            className='row g-0'
            style={{
              backgroundColor: '#FFF',
              minHeight: '400px',
              padding: '60px 20px',
              margin: '0',
            }}
          >
            <div className='col-12'>
              <div className='container'>
                <div className='row align-items-center g-4'>
                  <div className='col-12 col-lg-8 order-2 order-lg-1'>
                    <h2
                      className='mb-3 mb-md-4 text-center text-lg-start'
                      style={{
                        fontSize: 'clamp(1.4rem, 3.5vw, 2.2rem)',
                        fontWeight: '600',
                        lineHeight: '1.4',
                        fontFamily: 'Inter',
                      }}
                    >
                      <span style={{ color: '#2D5272' }}>
                        Inspired by Tesla. Powered by Compassion.
                      </span>
                    </h2>
                    <p
                      className='text-center text-lg-start'
                      style={{
                        fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                        lineHeight: '1.8',
                        maxWidth: '100%',
                        wordWrap: 'break-word',
                        fontFamily: 'Inter',
                        fontWeight: '400',
                        color: '#666666',
                      }}
                    >
                      Named in honor of inventor Nikola Tesla, who himself faced
                      emotional breakdowns despite his brilliance, Tesla Bird is
                      about more than just therapy—it's about illumination.
                      India's mental health crisis is growing rapidly. According
                      to the National Institute of Mental Health and
                      Neurosciences (NIMHANS), one in seven Indians suffers from
                      some form of mental disorder. For students, the pressure
                      of academic performance, social expectations, and an
                      uncertain future can be overwhelming. For working
                      professionals, long hours, digital fatigue, and lack of
                      work-life balance often lead to depression, anxiety, and
                      sleep disorders. In fact, a 2024 World Health Organization
                      (WHO) report ranked India among the top five most stressed
                      nations globally. At the heart of our platform is Aarava,
                      an AI-powered therapy companion offering 24/7 support in
                      multiple Indian languages. Aarava uses techniques like
                      CBT, mindfulness, and behavior science to offer real-time
                      help—grounded in cultural realities, not just clinical
                      jargon. We partner with experts, governments, and
                      institutions like WHO and NIMHANS to ensure everything we
                      build is credible and inclusive.
                    </p>
                  </div>
                  <div className='col-12 col-lg-4 d-flex justify-content-center order-1 order-lg-2'>
                    <div style={{ maxWidth: '280px', width: '100%' }}>
                      <img
                        src={Tesla || '/placeholder.svg'}
                        alt='nikolas-tesla'
                        className='img-fluid'
                        style={{
                          zIndex: 2,
                          maxWidth: '100%',
                          height: 'auto',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Impact Section */}
        <div className='container py-4 py-md-5'>
          <div className='row justify-content-center'>
            <div className='col-12 col-lg-10'>
              <h1
                className='mb-3 mb-md-4 text-center text-lg-start'
                style={{
                  fontFamily: 'Inter',
                  fontWeight: '600',
                  fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                  color: '#2D5272',
                }}
              >
                From Stress to Strength - Real Impact, Real People
              </h1>
              <p
                className='mb-3 text-center text-lg-start'
                style={{
                  fontFamily: 'Inter',
                  fontWeight: '500',
                  fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                  color: '#2D5272',
                  lineHeight: '1.6',
                }}
              >
                Whether it's campuses, offices, or rural communities, Tesla Bird
                is transforming how India deals with mental wellness. With over
                100,000 users impacted, our data shows a 40% improvement in
                emotional well-being in just 3 months using tools like the Tesla
                Bird.One of our core innovations is the Tesla Bird Happiness
                Index—a unique well-being assessment tool designed to measure
                emotional wellness across age groups and work environments.
                Using this index, companies and institutions can track burnout,
                motivation, and mental resilience while taking timely action to
                improve them. Early pilot studies using the index have shown a
                40% improvement in emotional well-being among participants over
                three months.
              </p>
              <p
                className='text-center text-lg-start'
                style={{
                  fontFamily: 'Inter',
                  fontWeight: '500',
                  fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                  color: '#2D5272',
                  lineHeight: '1.6',
                }}
              >
                We're a next-generation mental health platform blending
                technology, science, and empathy to make mental wellness
                accessible, culturally relevant, and deeply human.
              </p>
            </div>
          </div>
        </div>

        {/* Services Section */}
        <div className='container py-4 py-md-5'>
          {/* Header Section */}
          <div className='row mb-4 mb-md-5 align-items-stretch g-4'>
            <div className='col-12 col-lg-6 text-center text-lg-start d-flex align-items-center'>
              <h2
                style={{
                  backgroundImage:
                    'linear-gradient(90deg, #87A3BB -23.85%, #2D5272 128.3%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  color: 'transparent',
                  WebkitTextFillColor: 'transparent',
                  fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 600,
                  display: 'inline-block',
                  margin: 0,
                }}
              >
                — Our services include
              </h2>
            </div>

            {/* Face to face group session */}
            <div className='col-12 col-lg-6 d-flex justify-content-center'>
              <div
                className='card border-0 shadow-sm h-100 w-100'
                style={{
                  backgroundColor: '#2D5272',
                  borderRadius: '20px',
                  color: 'white',
                  maxWidth: '450px',
                }}
              >
                <div className='card-body p-3 p-md-4'>
                  <div className='d-flex justify-content-between align-items-start mb-3'>
                    <h5
                      className='card-title fw-bold mb-0'
                      style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }}
                    >
                      Face to face group session
                    </h5>
                    <div style={{ fontSize: '1.5rem', marginLeft: '15px' }}>
                      👥
                    </div>
                  </div>
                  <p
                    className='card-text mb-0'
                    style={{
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                      lineHeight: '1.5',
                      opacity: '0.9',
                    }}
                  >
                    Join our in-person sessions for guided discussions, shared
                    learning, and real-time connection in a supportive group
                    setting.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Services Grid */}
          <div className='row mb-4 mb-md-5 g-4'>
            {/* Health Checks and Consultation */}
            <div className='col-12 col-md-6 col-lg-6 d-flex justify-content-center'>
              <div
                className='card border-0 shadow-sm h-100 w-100'
                style={{
                  backgroundColor: '#2D5272',
                  borderRadius: '20px',
                  color: 'white',
                  maxWidth: '450px',
                }}
              >
                <div className='card-body p-3 p-md-4'>
                  <div className='d-flex justify-content-between align-items-start mb-3'>
                    <h5
                      className='card-title fw-bold mb-0'
                      style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }}
                    >
                      Health Checks and Consultation
                    </h5>
                    <div style={{ fontSize: '1.5rem', marginLeft: '15px' }}>
                      🩺
                    </div>
                  </div>
                  <p
                    className='card-text mb-0'
                    style={{
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                      lineHeight: '1.5',
                      opacity: '0.9',
                    }}
                  >
                    Quick health assessments and expert guidance to support
                    early detection, prevention, and overall wellbeing.
                  </p>
                </div>
              </div>
            </div>

            {/* Aarava - 24/7 AI Therapist */}
            <div className='col-12 col-md-6 col-lg-6 d-flex justify-content-center'>
              <div
                className='card border-0 shadow-sm h-100 w-100'
                style={{
                  backgroundColor: '#2D5272',
                  borderRadius: '20px',
                  color: 'white',
                  maxWidth: '450px',
                }}
              >
                <div className='card-body p-3 p-md-4'>
                  <div className='d-flex justify-content-between align-items-start mb-3'>
                    <h5
                      className='card-title fw-bold mb-0'
                      style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }}
                    >
                      Aarava - 24/7 AI Therapist
                    </h5>
                    <div style={{ fontSize: '1.5rem', marginLeft: '15px' }}>
                      🤖
                    </div>
                  </div>
                  <p
                    className='card-text mb-0'
                    style={{
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                      lineHeight: '1.5',
                      opacity: '0.9',
                    }}
                  >
                    Your always-available AI companion for mental health
                    support—chat anytime for guidance, coping tools, and
                    emotional check-ins.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className='row mt-4 mt-md-5 g-4'>
            {/* Mental wellness kits */}
            <div className='col-12 col-md-6 col-lg-6 d-flex justify-content-center'>
              <div
                className='card border-0 shadow-sm h-100 w-100'
                style={{
                  backgroundColor: '#2D5272',
                  borderRadius: '20px',
                  color: 'white',
                  maxWidth: '450px',
                }}
              >
                <div className='card-body p-3 p-md-4'>
                  <div className='d-flex justify-content-between align-items-start mb-3'>
                    <h5
                      className='card-title fw-bold mb-0'
                      style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }}
                    >
                      Mental wellness kits
                    </h5>
                    <div style={{ fontSize: '1.5rem', marginLeft: '15px' }}>
                      📦
                    </div>
                  </div>
                  <p
                    className='card-text mb-0'
                    style={{
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                      lineHeight: '1.5',
                      opacity: '0.9',
                    }}
                  >
                    Ready-to-use kits with tools, resources, and activities to
                    support mental, physical, and emotional wellbeing in local
                    communities.
                  </p>
                </div>
              </div>
            </div>

            {/* WHO Approved Assessments */}
            <div className='col-12 col-md-6 col-lg-6 d-flex justify-content-center'>
              <div
                className='card border-0 shadow-sm h-100 w-100'
                style={{
                  backgroundColor: '#2D5272',
                  borderRadius: '20px',
                  color: 'white',
                  maxWidth: '450px',
                }}
              >
                <div className='card-body p-3 p-md-4'>
                  <div className='d-flex justify-content-between align-items-start mb-3'>
                    <h5
                      className='card-title fw-bold mb-0'
                      style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }}
                    >
                      WHO Approved Assessments
                    </h5>
                    <div style={{ fontSize: '1.5rem', marginLeft: '15px' }}>
                      📋
                    </div>
                  </div>
                  <p
                    className='card-text mb-0'
                    style={{
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                      lineHeight: '1.5',
                      opacity: '0.9',
                    }}
                  >
                    Standardized mental health and wellbeing tools validated by
                    the World Health Organization for accurate, reliable
                    insights.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className='row mt-4 mt-md-5'>
            <div className='col-12'>
              <div className='mb-3 mb-md-4'>
                <h2
                  className='text-center text-lg-start'
                  style={{
                    color: '#2D5272',
                    fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                    fontWeight: '600',
                    marginBottom: '2rem',
                  }}
                >
                  Wellness for Everyone, Everywhere
                </h2>
              </div>
              <div className='row'>
                <div className='col-12 col-lg-10'>
                  <div
                    style={{
                      color: '#6c757d',
                      fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                      lineHeight: '1.8',
                    }}
                  >
                    <p className='mb-3 text-center text-lg-start'>
                      Mental health is not one-size-fits-all. That's why we go
                      local—with content and care available in Kannada, Hindi,
                      Tamil, and English. We reach beyond screens—with on-ground
                      workshops, telehealth networks, and our "Mental Health in
                      a Box" kits delivered to schools, small businesses, and
                      healthcare centers—bringing structured, scalable care to
                      the grassroots.
                    </p>
                    <p className='mb-3 text-center text-lg-start'>
                      Tesla Bird is building a future where mental health is not
                      a luxury, but a right.
                    </p>
                    <p className='mb-3 text-center text-lg-start'>
                      Mental health has historically received less than 1% of
                      India's total health budget. Tesla Bird is determined to
                      bridge this gap through scalable, cost-effective, and
                      culturally sensitive solutions. Our "Mental Health in a
                      Box" initiative delivers comprehensive mental health
                      resources to small businesses, schools, and healthcare
                      centers, enabling grassroots impact.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mental Health Issues Sections */}
        <div className='container py-4 py-md-5'>
          {/* Students Section */}
          <h2 style={titleStyle}>
            Some of the top mental health issues in students :
          </h2>
          <div style={sectionStyle}>
            <div className='row g-3 g-md-4'>
              {studentIssues.map((column, columnIndex) => (
                <div key={columnIndex} className='col-12 col-sm-6 col-lg'>
                  <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                    {column.map((issue, index) => (
                      <li key={index} style={listItemStyle}>
                        <span
                          style={{
                            position: 'absolute',
                            left: '0',
                            color: '#48bb78',
                            fontWeight: 'bold',
                          }}
                        >
                          •
                        </span>
                        {issue}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* Working Professionals Section */}
          <h2 style={titleStyle}>
            Some of the top mental health issues in working professionals :
          </h2>
          <div style={sectionStyle}>
            <div className='row g-3 g-md-4'>
              {professionalIssues.map((column, columnIndex) => (
                <div key={columnIndex} className='col-12 col-sm-6 col-lg'>
                  <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                    {column.map((issue, index) => (
                      <li key={index} style={listItemStyle}>
                        <span
                          style={{
                            position: 'absolute',
                            left: '0',
                            color: '#48bb78',
                            fontWeight: 'bold',
                          }}
                        >
                          •
                        </span>
                        {issue}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* Closing Section */}
          <div className='row mb-4 mb-md-5'>
            <div className='col-12 col-lg-10'>
              <div
                style={{
                  color: '#6c757d',
                  fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                  lineHeight: '1.8',
                }}
              >
                <p className='mb-3 text-center text-lg-start'>
                  With support from education policy makers and corporate
                  leaders, Tesla Bird is now working to integrate wellness
                  programs into the National Education Policy (NEP) and
                  state-level employee welfare schemes. Globally, we are
                  aligning with the WHO's digital mental health agenda to scale
                  our solutions across Asia and Africa.
                </p>
                <p className='mb-3 text-center text-lg-start'>
                  Tesla Bird isn't just a platform—it's a movement to make
                  mental health mainstream. We are reimagining therapy,
                  normalizing emotional conversations, and fostering a
                  generation that values psychological fitness as much as
                  physical health.
                </p>
                <p className='mb-4 mb-md-5 text-center text-lg-start'>
                  Whether you're a student facing exam stress, a professional
                  battling burnout, or a homemaker seeking peace of mind—Tesla
                  Bird is here for you.
                </p>
                <h2
                  className='text-center text-lg-start'
                  style={{
                    color: '#2D5272',
                    fontSize: 'clamp(1.3rem, 3vw, 1.8rem)',
                    fontWeight: '600',
                  }}
                >
                  Join us as we help India and the world heal, grow, and
                  thrive—one mind at a time.
                </h2>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  )
}

export default Wellness
